import { render, staticRenderFns } from "./InputSelectBasic.vue?vue&type=template&id=4faacb68"
import script from "./InputSelectBasic.vue?vue&type=script&lang=js"
export * from "./InputSelectBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports